function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7845",
  "data-name": "Group 7845",
  transform: "translate(-598 -324.346)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6071",
  "data-name": "Group 6071"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5706",
  "data-name": "Group 5706",
  transform: "translate(687.629 487.291)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5372",
  "data-name": "Rectangle 5372",
  width: 47.48,
  height: 5.715,
  transform: "translate(0 0)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_6069",
  "data-name": "Group 6069"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5721",
  "data-name": "Group 5721",
  transform: "translate(-12.5 -6.158)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3442",
  "data-name": "Path 3442",
  d: "M58.562,140.549a17.585,17.585,0,0,0-17.305,14.64h-.264a29.281,29.281,0,1,1,0-58.562h3.192a17.548,17.548,0,0,0,34.61,0H108.6a17.548,17.548,0,0,0,34.61,0h3.192a35.137,35.137,0,1,0,0-70.274H122.717a17.548,17.548,0,0,0-34.61,0H64.419V2.928A2.927,2.927,0,0,0,61.49,0H2.928A2.927,2.927,0,0,0,0,2.928v46.85a2.927,2.927,0,0,0,2.928,2.928H61.49a2.927,2.927,0,0,0,2.928-2.928V32.209H88.107a17.548,17.548,0,0,0,34.61,0h23.688a29.281,29.281,0,1,1,0,58.562h-3.192a17.548,17.548,0,0,0-34.61,0H78.8a17.548,17.548,0,0,0-34.61,0H40.994a35.137,35.137,0,1,0,0,70.274h.264a17.548,17.548,0,0,0,34.61,0h6.12v-5.856h-6.12A17.585,17.585,0,0,0,58.562,140.549ZM29.281,5.856h5.856V17.569H29.281ZM58.562,46.85H5.856V5.856H23.425V20.5a2.927,2.927,0,0,0,2.928,2.928H38.065A2.927,2.927,0,0,0,40.994,20.5V5.856H58.562Zm46.85-5.856a11.712,11.712,0,1,1,11.712-11.712A11.724,11.724,0,0,1,105.412,40.993Zm20.5,40.993A11.712,11.712,0,1,1,114.2,93.7,11.724,11.724,0,0,1,125.909,81.987Zm-64.419,0A11.712,11.712,0,1,1,49.778,93.7,11.724,11.724,0,0,1,61.49,81.987ZM58.562,169.83a11.712,11.712,0,1,1,11.712-11.712A11.724,11.724,0,0,1,58.562,169.83Z",
  transform: "translate(619.676 338.258)"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_tick_3923816",
  transform: "translate(783.574 426.926)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3432",
  "data-name": "Path 3432",
  d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.946,11.532-8.4,7.7a1.4,1.4,0,0,1-1.936-.042l-4.2-4.2a1.4,1.4,0,1,1,1.98-1.98l3.252,3.252,7.412-6.794a1.4,1.4,0,0,1,1.893,2.064Z",
  transform: "translate(-1 8)",
  fill: "#f37320"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3424",
  "data-name": "Path 3424",
  d: "M11237.627,20190.123l-31.055,25.463v39.717h62.706v-38.818Z",
  transform: "translate(-10471.463 -19732.201)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3423",
  "data-name": "Path 3423",
  d: "M0,0,24.72,17.673",
  transform: "matrix(-0.259, 0.966, -0.966, -0.259, 755.164, 455.285)",
  fill: "none",
  stroke: "#f37320",
  strokeLinecap: "round",
  strokeWidth: 4
}))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5575",
  "data-name": "Rectangle 5575",
  width: 75,
  height: 64,
  transform: "translate(598 325)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "noun_forms_1236251",
  transform: "translate(608.011 319.945)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3398",
  "data-name": "Path 3398",
  d: "M64.99,22.576a1.432,1.432,0,0,0-.408-1L48.16,4.83a1.432,1.432,0,0,0-1.024-.43h-24.7a7.159,7.159,0,0,0-7.159,7.159V62.55a7.159,7.159,0,0,0,7.159,7.159H57.831A7.159,7.159,0,0,0,64.99,62.55ZM48.453,9.2,60.83,21.831H50.6a2.148,2.148,0,0,1-2.148-2.148Zm9.378,57.641H22.439a4.3,4.3,0,0,1-4.3-4.3V11.537a4.3,4.3,0,0,1,4.3-4.3H45.59V19.684A5.011,5.011,0,0,0,50.6,24.695H62.126V62.55A4.3,4.3,0,0,1,57.831,66.845Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3399",
  "data-name": "Path 3399",
  d: "M61.274,48.26H41.982a1.432,1.432,0,1,0,0,2.863H61.274a1.432,1.432,0,1,0,0-2.863Z",
  transform: "translate(-7.18 -12.462)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3400",
  "data-name": "Path 3400",
  d: "M29.648,47.26a2.148,2.148,0,1,0,0,4.3h.036a2.148,2.148,0,1,0-.036-4.3Z",
  transform: "translate(-3.472 -12.178)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3401",
  "data-name": "Path 3401",
  d: "M61.274,61.26H41.982a1.432,1.432,0,1,0,0,2.863H61.274a1.432,1.432,0,1,0,0-2.863Z",
  transform: "translate(-7.18 -16.156)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3402",
  "data-name": "Path 3402",
  d: "M29.648,60.26a2.148,2.148,0,1,0,0,4.3h.036a2.148,2.148,0,1,0-.036-4.3Z",
  transform: "translate(-3.472 -15.872)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3403",
  "data-name": "Path 3403",
  d: "M61.274,74.26H41.982a1.432,1.432,0,1,0,0,2.863H61.274a1.432,1.432,0,1,0,0-2.863Z",
  transform: "translate(-7.18 -19.85)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3404",
  "data-name": "Path 3404",
  d: "M29.648,73.26a2.148,2.148,0,1,0,0,4.3h.036a2.148,2.148,0,1,0-.036-4.3Z",
  transform: "translate(-3.472 -19.566)"
})));

function SvgStepper5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214.574,
    height: 201.254,
    viewBox: "0 0 214.574 201.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper5);
export default __webpack_public_path__ + "static/media/stepper5.7a2217b86a849976f9c7bc0e6134a44f.svg";
export { ForwardRef as ReactComponent };